








































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { Form } from "element-ui";
import { appTypeDic, platformTypeDic } from "@/enum";
import {
  addEviApp,
  updateEviApp,
  deleteEviApp,
  getEviAppPageList,
  defaultEviAppData
} from "@/api/eviapp";
import { IEviApp } from "@/model/eviapp";
import Pagination from "@/components/Pagination/index.vue";

@Component({
  name: "eviApp",
  components: {
    Pagination
  },
  filters: {
    appTypeFilter: (key: number) => {
      return appTypeDic.find((o: any) => o.key === key)?.value;
    },
    platformTypeFilter: (key: number) => {
      return platformTypeDic.find((o: any) => o.key === key)?.value;
    }
  }
})
export default class extends Vue {
  private tableKey = 0;
  private eviAppData = defaultEviAppData;
  private list: IEviApp[] = [];
  private total = 0;
  private listLoading = false;
  private appTypeDic = appTypeDic;
  private platformTypeDic = platformTypeDic;
  private listQuery = {
    pageIndex: 1,
    pageSize: 20,
    search: "",
    appType: -1
  };

  private dialogCreateVisible = false;

  private createRules = {
    appName: [{ required: true, message: "应用名称必填", trigger: "blur" }],
    appType: [
      {
        type: "number",
        min: 0,
        required: true,
        message: "应用类别必填",
        trigger: "change"
      }
    ],
    platformType: [
      {
        required: true,
        message: "服务平台必填",
        trigger: "blur"
      }
    ]
    // whiteList: [{ required: true, message: "白名单必填", trigger: "blur" }]
  };

  private handleFilter() {
    this.listQuery.pageIndex = 1;
    this.getList();
  }

  private openCreateDialog() {
    this.initData();
    this.dialogCreateVisible = true;
  }

  private closeCreateDialog() {
    (this.$refs.createForm as Form).resetFields();
    this.dialogCreateVisible = false;
  }

  created() {
    this.getList();
  }

  private handleUpdate(data: IEviApp) {
    this.dialogCreateVisible = true;
    // this.eviAppData = data;
    this.setData(data);
  }

  private initData() {
    this.eviAppData.id = "";
    this.eviAppData.appName = "";
    this.eviAppData.app_Key = "";
    this.eviAppData.app_Secret = "";
    this.eviAppData.appType = -1;
    this.eviAppData.platformType = 1;
    this.eviAppData.memberId = "";
    this.eviAppData.whiteList = "";
    this.eviAppData.createTime = null;
    this.eviAppData.updateTime = null;
  }

  private setData(data: IEviApp) {
    this.eviAppData.id = data.id;
    this.eviAppData.appName = data.appName;
    this.eviAppData.app_Key = data.app_Key;
    this.eviAppData.app_Secret = data.app_Secret;
    this.eviAppData.appType = data.appType;
    this.eviAppData.platformType = data.platformType;
    this.eviAppData.memberId = data.memberId;
    this.eviAppData.whiteList = data.whiteList;
    this.eviAppData.createTime = data.createTime;
    this.eviAppData.updateTime = data.updateTime;
  }

  private deleteEviApp(id: string) {
    this.$confirm("此操作将永久删除该应用, 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    })
      .then(async () => {
        await deleteEviApp(id).then(() => {
          this.getList();

          this.$message({
            type: "success",
            message: "删除成功!"
          });
        });
      });
    // .catch(() => {
    //   this.$message({
    //     type: "info",
    //     message: "已取消删除"
    //   });
    // });
  }

  private async updateEviApp() {
    (this.$refs.createForm as Form).validate(async valid => {
      if (valid) {
        this.eviAppData.whiteList = this.eviAppData.whiteList.trim();
        await updateEviApp(this.eviAppData);

        this.$message({
          message: "修改成功",
          type: "success",
          duration: 2000
        });

        this.initData();
        this.dialogCreateVisible = false;
        this.getList();
      }
    });
  }

  private async createEviApp() {
    (this.$refs.createForm as Form).validate(async valid => {
      if (valid) {
        // this.eviAppData.whiteList = this.eviAppData.whiteList.trim();
        await addEviApp(this.eviAppData).then(() => {
          this.$message({
            message: "创建成功",
            type: "success",
            duration: 2000
          });

          this.initData();
          this.dialogCreateVisible = false;
          this.getList();
        });
      }
    });
  }

  // 获取列表数据
  private async getList() {
    this.listLoading = true;
    const { data } = await getEviAppPageList(this.listQuery);
    this.list = data.list;
    this.total = data.total;
    // Just to simulate the time of the request
    setTimeout(() => {
      this.listLoading = false;
    }, 0.5 * 1000);
  }
}
